import { createAsyncThunk } from '@reduxjs/toolkit'
import { ColumnFiltersState } from '@tanstack/react-table'
import { Axios } from 'api/axios'
import axios from 'axios'
const API_URL = process.env.REACT_APP_BASE_URL
const headers = {
  'Content-Type': 'application/json'
}

export interface Team {
  id?: number
  packageName: string
  districtCode: string
  districtName: string
  state: string
  status: boolean
  createBy?: string
  updatedBy?: string
  createDate?: string
  updateDate?: string
}
export interface PaginatedResponse<T> {
  count: number
  total_pages: number
  next: string | null
  previous: string | null
  results: T[]
}

export const fetchTeam = createAsyncThunk(
  'team/fetchTeam',
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: 'asc' | 'desc' | '';
    filters?: ColumnFiltersState;
  }) => {
    try {
      const params: Record<string, any> = {
        page,
        page_size: pageSize,
      };

      if (search) params.search = search?.trim() || '';

      // Sort key map for frontend-to-backend translation
      const sortKeyMap: Record<string, string> = {
        department_name: 'department_name',     // backend expects single underscore
        organization_name: 'organization_name',
        team_name: 'team_name',
        created_at: 'created_at',
        updated_at: 'updated_at',
        // Add more mappings if needed
      };

      if (sort) {
        const backendSortKey = sortKeyMap[sort] || sort;
        params.ordering = order === 'desc' ? `-${backendSortKey}` : backendSortKey;
      }

      console.log('Sort key sent to backend:', params.ordering);

     
      if (filters && Array.isArray(filters)) {
        filters.forEach((filter) => {
          const { id, value } = filter;
          if (!id || value === undefined || value === '') return;

          if ((id === 'updated_at' || id === 'created_at') && typeof value === 'object') {
            const { from_date, to_date } = value as {
              from_date?: string;
              to_date?: string;
            };

            if (id === 'updated_at') {
              if (from_date) params['updated_at_from'] = from_date;
              if (to_date) params['updated_at_to'] = to_date;
            }
            if (id === 'created_at') {
              if (from_date) params['created_at_from'] = from_date;
              if (to_date) params['created_at_to'] = to_date;
            }
          } else {
            params[id] = value;
          }
        });
      }

      const response: any = await Axios.get(`/teams/`, { params });

      const responseData = response.data;
      return {
        data: responseData.data || responseData.results || [],
        rowCount: responseData.count || 0,
      };
    } catch (error: any) {
      console.error('fetchTeam error:', error.response?.data || error.message);
      throw new Error('Failed to fetch teams');
    }
  }
);

export const fetchTeamsById = createAsyncThunk(
  'team/fetchById',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/teams${id}/`)
      console.log('resp to update Id : ', response)
      return response
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || 'Failed to fetch fetchTeamsById by ID'
      )
    }
  }
)

export const updateTeam = createAsyncThunk(
  `/organisation/updateTeam`,
  async (packageData: any) => {
    // const token = localStorage.getItem("authToken");
    // if (!token) {
    //   throw new Error("No authentication token found");
    // }
    console.log('pkgData:', packageData)
    const response: any = await Axios.put(
      `${API_URL}/team/${packageData.id}/`,
      packageData
    )
    console.log('updateTeam response:', response)
    return response
  }
)
export const updateStatusInTeam = createAsyncThunk(
  `/team/updateStatusInTeam`,
  async (teamsData: any) => {
    const response: any = await Axios.put(
      `/teams/${teamsData?.team_id}/update/`,
      teamsData
    )
    return response
  }
)

export const addTeam = createAsyncThunk(
  `/team/addTeam`,
  async (packageData: any) => {
    // const token = localStorage.getItem("authToken");
    // if (!token) {
    //   throw new Error("No authentication token found");
    // }

    const response = await Axios.post(`${API_URL}organisation/`, packageData)
    console.log('addTeam response:', response)
    console.log('addTeam response:', response.data)
    return response.data
  }
)

export const deleteOrganisation = createAsyncThunk(
  `/team/delete`,
  async (id: number, { rejectWithValue }) => {
    try {
      await axios.delete(`${API_URL}/${id}`, { headers })
      return id
    } catch (err: any) {
      console.error('Delete error:', err)
      return rejectWithValue(err.response?.data?.message || err.message)
    }
  }
)

// Exports department CSV file
export const exportOTeamsCSV = createAsyncThunk(
  'teams/exportOTeamsCSV',
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('authToken')
      const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        Accept: '*/*'
      }
      // Use responseType: 'blob' to get the file as a blob
      const response = await Axios.get('/teams/get-all?export=excel', {
        headers,
        responseType: 'blob'
      })
      // Return the blob and filename (if any)
      return {
        blob: response.data,
        filename:
          response.headers['content-disposition']
            ?.split('filename=')[1]
            ?.replace(/"/g, '') || 'teams.csv'
      }
    } catch (err: any) {
      console.error('Export CSV error:', err)
      return rejectWithValue(err.message || 'Failed to export CSV')
    }
  }
)


export const TeamExportsCSV = async ({
  search,
  filters,
}: {
  search?: string;
  filters?: any;
}) => {
  const params = new URLSearchParams();
  params.append("export", "excel");

  if (search) params.append("search", search);

  if (filters && filters.length > 0) {
    filters.forEach(({ id, value }: { id: string; value: any }) => {
      if (id && value !== undefined && value !== null) {
        if (typeof value === "object" && value !== null) {
          const maybeDateFilter = value as {
            from_date?: string;
            to_date?: string;
          };

          if (maybeDateFilter.from_date || maybeDateFilter.to_date) {
            if (maybeDateFilter.from_date) {
              params.append(`${id}_from`, maybeDateFilter.from_date);
            }
            if (maybeDateFilter.to_date) {
              params.append(`${id}_to`, maybeDateFilter.to_date);
            }
            return;
          }

          Object.entries(value).forEach(([key, val]) => {
            if (val !== undefined && val !== null && val !== "") {
              params.append(key, String(val));
            }
          });
        } else {
          params.append(id, String(value));
        }
      }
    });
  }

  console.log("Exporting URL:", `/teams/?${params.toString()}`);

  const response = await Axios.get(`/teams/?${params.toString()}`, {
    responseType: "blob",
  });

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "Team.csv",
  };
};




export const fetchAllDropdowns = createAsyncThunk(
  'team/fetchAllDropdowns',
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/team/dropdown/`)
      console.log('resp to update Id  dropdwon: ', response)
      return response.data
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || 'Failed to fetch package list'
      )
    }
  }
)

export const fetchAllDropdownsTeams = createAsyncThunk(
  'teams/fetchAllDropdownsTeams',
  async () => {
    try {
      console.log('fetchAllDropdownsTeams called')
      const [orgRes, teamsRes, departmentRes] = await Promise.all([
        Axios.get(`${API_URL}/organization/all-org/`, { headers }),
        Axios.get(`${API_URL}/teams/team_dropdown/`, { headers }), 
        Axios.get(`${API_URL}/department/get-all/`, { headers }) 
      ])
      // Log to inspect structure
      console.log('orgRes.data:', orgRes.data)
      console.log('teamsRes.data:', teamsRes.data)
      console.log('departmentRes.data:', departmentRes.data)

      return {
        orgDropDown: Array.isArray(orgRes.data.data)
          ? orgRes.data.data.map((item: any) => ({
              id: item.organization_id,
              name: item.organization_name
            }))
          : [],
        departmentDropDown: Array.isArray(departmentRes.data.data)
          ? departmentRes.data.data.map((item: any) => ({
              id: item.department_id,
              name: item.department_name
            }))
          : [],
        teamsDropDown: Array.isArray(teamsRes.data.data)
          ? teamsRes.data.data.map((item: any) => ({
              id: item.team_id,
              name: item.team_name
            }))
          : []
      }
    } catch (err) {
      console.log(err)
      throw err
    }
  }
)

export const fetchDepartmentsByOrg = createAsyncThunk(
  'departments/fetchByOrg',
  async (orgId: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        `/department/by-org/?organization_id=${orgId}`
      )
      // Adjust this based on your API response structure
      return response.data.data
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || 'Failed to fetch departments'
      )
    }
  }
)
